import React, { Component, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);


const BarRanking = (props) => {
    const [rankingData, setRankingData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        populateRankingData();
    }, [props.searchButtonPressed]);


    const data = {
        labels: rankingData.map((item) => item.ranking),
            datasets: [{
                label: t('Dashboard.Label.Approved'),
                data: rankingData.map((item) => item.submission_Count),
                backgroundColor: rankingData.map((item) => item.color),
                borderColor: rankingData.map((item) => item.color),
                borderWidth: 1
            }]
        };
    const options = {
            scales: {
                x: {
                
                    grid: {
                        display: false
                    }
                },
                y: {
                    display: false,
                    grid: {
                        display: false
                    }
                }
            },
            responsive: true,
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: "Ranking"
                }
            }
        };
    

    async function populateRankingData() {
        setIsLoading(true);
        const encodedType = encodeURIComponent(props.type ? props.type : "grabber");
        const encodedPhoneNo = encodeURIComponent(props.phoneNo ? props.phoneNo : "NOSEARCH");
        const encodedCarPlate = encodeURIComponent(props.carPlate ? props.carPlate : "NOSEARCH");
        const encodedEmail = encodeURIComponent(props.email ? props.email : "NOSEARCH");

        const response = await fetch(`form/ranking?type=${encodedType}&email=${encodedEmail}&phoneNo=${encodedPhoneNo}&carPlate=${encodedCarPlate}`);
        const data = await response.json();
        setRankingData(data);
        setIsLoading(false);
    }


    return (
        <div className = "div-bar-ranking">
            <label className="label-submission" >{t('Dashboard.Label.Ranking')}</label>
            <br />
            {rankingData.length > 0 && !isLoading ? (
                <Bar data={data} options={options} /> 
            ) : (
                <img src="https://spagblob.blob.core.windows.net/odin-image/Loading.gif" alt="loading" />
            )}                                  


        </div>
    );

}

export default BarRanking;
